import React, { useEffect, useRef, useState } from "react";
import "./DraggableButton.css"; // Importing CSS file
import { MessageOutlined } from "@ant-design/icons";

interface FloatingButtonProps {
  // showDrawer: () => void;
  // showTimeline: () => void;
  showChatter: () => void;
}

const FloatingChatButton: React.FC<FloatingButtonProps> = ({
  // showDrawer,
  // showTimeline,
  showChatter,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const scaleFactor = 0.67;

  useEffect(() => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    setPosition({
      x: (windowWidth - 130) / scaleFactor, // Adjust for button width
      y: (windowHeight - 60) / scaleFactor, // Adjust for button height
    });
  }, [window.innerWidth]);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX / scaleFactor - position.x,
      y: e.clientY / scaleFactor - position.y,
    });
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;

    const newX = e.clientX / scaleFactor - dragStart.x;
    const newY = e.clientY / scaleFactor - dragStart.y;

    const windowWidth = window.innerWidth / scaleFactor;
    const windowHeight = window.innerHeight / scaleFactor;

    setPosition({
      x: Math.max(0, Math.min(newX, windowWidth - 100 / scaleFactor)),
      y: Math.max(0, Math.min(newY, windowHeight - 60 / scaleFactor)),
    });
  };

  const handleMouseUp = () => setIsDragging(false);
  const handleMouseEnter = () => setIsExpanded(true);
  const handleMouseLeave = () => setIsExpanded(false);
  const floatingRef = useRef<any>(null);
  const handleClickOutside = (event: any) => {
    if (floatingRef.current && !floatingRef?.current?.contains(event.target)) {
      handleMouseLeave();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={floatingRef}
      className={`floating-container`}
      style={{ top: `${position.y}px`, left: `${position.x}px` }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <div
        className="floating-button"
        onMouseDown={handleMouseDown}
        onMouseEnter={handleMouseEnter}
        onClick={showChatter}
      >
        <MessageOutlined />
        <span className="label">Chat</span>
      </div>
      <div
        className={`element-container ${isExpanded ? "visible" : ""}`}
        // onMouseLeave={handleMouseLeave}
        style={{ display: "none" }}
      >
        {/* <div
          className="float-element"
          style={{ borderRight: "0.4px solid  #D1D1D1" }}
          onClick={showTimeline}
        >
          <i className="material-icons">timeline</i>
          <span>Time Line</span>
        </div>
        <div
          className="float-element"
          // style={{ borderRight: "0.4px solid  #D1D1D1" }}
          onClick={showDrawer}
        >
          <i className="material-icons">description</i>
          <span>Document</span>
        </div> */}
        <div className="float-element" onClick={showChatter}>
          <i className="material-icons">message</i>

          <span>Chat</span>
        </div>
      </div>
    </div>
  );
};

export default FloatingChatButton;
